import React from 'react';
import './TicketHistory.scss';
import {IWorkFlowStatus} from '@shared/services/service-mappers/WorkflowMapper';
import TicketActivityItem, {
  ITicketingSystemTicketActivityItemProps
} from '../TicketActivityItem/TicketActivityItem';

interface TicketHistory {
  clinicUsersList: any[];
  statuses: IWorkFlowStatus[];
  selectedDataList: {
    data: any[];
    isLoading: boolean;
  };
  renderTicketActivityItemContent?: ITicketingSystemTicketActivityItemProps['renderTicketActivityItemContent'];
}
const TicketHistory = (props: TicketHistory): JSX.Element => {
  const {
    clinicUsersList,
    statuses,
    selectedDataList,
    renderTicketActivityItemContent
  } = props;

  return (
    <section className="ticketing-system-ticket-history-wrapper">
      <div className="history-wrapper">
        {selectedDataList.data.map((historyItem, idx) => (
          <TicketActivityItem
            renderTicketActivityItemContent={renderTicketActivityItemContent}
            allUsers={clinicUsersList}
            statuses={statuses}
            key={idx}
            item={historyItem}
          />
        ))}
      </div>
    </section>
  );
};

export default TicketHistory;
